import React, { useEffect } from "react";
import imgI from "../assets/images/icons/arrowI.svg";
import imgD from "../assets/images/icons/arrowD.svg";
import useStore from "../store/useStore";
import TeamCard from "./TeamCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function Team() {
  const { nosotrosTeams, getNosotrosTeams } = useStore();
  useEffect(() => {
    getNosotrosTeams();
  }, [getNosotrosTeams]);

  return (
    <>
      <div className="w-full  bg-sidom-blue mb-[70px] md:mb-[100px] lg:mb-[90px]">
        <div className=" px-2 md:px-0 lg:px-0 mx-auto">
          <div className="container">
            <div className="grid grid-cols-1 text-center">
              <h1 className=" text-3xl md:text-[40px] lg:text-[45px] leading-tight mt-[70px] md:mt-[100px] lg:mt-[90px] text-sidom-orange font-bold mb-[60px] text-left">
                Conozca a nuestro Team
              </h1>
            </div>

            <div className="mt-6">
              <Swiper
                modules={[Navigation, Autoplay]}
                spaceBetween={20}
                slidesPerView={1}
                pagination={{ clickable: true }}
                autoplay={{ delay: 4000, disableOnInteraction: false }}
                breakpoints={{
                  640: { slidesPerView: 2 },
                  1024: { slidesPerView: 3 },
                  1400: { slidesPerView: 4 },
                }}
                className="team-swiper"
              >
                {nosotrosTeams?.map((item, index) => (
                  <SwiperSlide key={index}>
                    <TeamCard item={item} />
                  </SwiperSlide>
                ))}
              </Swiper>
              <button className="swiper-button-prev-custom absolute -left-1 top-[60%] -translate-y-1/2 z-20 p-1 hover:opacity-75 transition-all duration-300">
                <img src={imgI} alt="Flecha izquierda" className="w-5" />
              </button>
              <button className="swiper-button-next-custom absolute -right-1 top-[60%] -translate-y-1/2 z-20 p-1 hover:opacity-75 transition-all duration-300">
                <img src={imgD} alt="Flecha derecha" className="w-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
